<template>
  <div>

    <!-- INLINE -->
    <b-form-group v-if="render=='inline'"
                  :label="hideLabel ? null : control.tag"
                  :description="description"
                  :disabled="disabled">
      <b-input-group size="sm">
        <b-form-input :list="'list' + control.tag"
                      @click="find()"
                      @keyup="find()"
                      @blur.native="selectedItemByString()"
                      v-model="filter"
                      :placeholder="placeholder"
                      :state="isObjectSelected"
                      autocomplete="off">
        </b-form-input>
        <b-input-group-append v-if="selectObject">
          <b-button variant="outline-secondary"
                    v-b-tooltip.hover
                    :title="'Limpiar ' + control.tag"
                    @click="clearObjectSelected()">
            <AppIcon name="x" class="text-danger"></AppIcon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-invalid-feedback v-html="control.alert" />
      <datalist :id="'list' + control.tag">
        <option v-for="item in data" :key="item.id">{{ getList(item) }}</option>
      </datalist>
    </b-form-group>

    <!-- SEARCH -->
    <b-form-group v-if="render=='search'"
                  :label="hideLabel ? null : control.tag"
                  :description="description"
                  :disabled="disabled">
      <b-input-group size="sm">
        <b-form-input @keyup="openSearch()"
                      @click="openSearch()"
                      v-model="filter"
                      :placeholder="placeholder"
                      :state="isObjectSelected"
                      autocomplete="off">
        </b-form-input>
        <b-input-group-append v-if="selectObject">
          <b-button variant="outline-secondary"
                    v-b-tooltip.hover
                    :title="'Limpiar ' + control.tag"
                    @click="clearObjectSelected()">
            <AppIcon name="x" class="text-danger"></AppIcon>
          </b-button>
        </b-input-group-append>
        <b-input-group-append>
          <b-button variant="outline-secondary"
                    v-b-tooltip.hover
                    :title="'Buscar ' + control.tag"
                    @click="openSearch()">
            <AppIcon name="search"></AppIcon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-invalid-feedback v-html="control.alert" />
    </b-form-group>

    <!-- MODAL -->
    <b-modal v-model="modal.search.active"
             size="lg"
             no-close-on-esc
             no-close-on-backdrop
             hide-header-close
             @shown="focusSearchInput"
             body-class="find-modal-body">

      <div slot="modal-header" class="app-modal-header">
        <span class="app-modal-header__icon">
          <AppIcon :name="showQuickAdd ? (editingItem ? 'edit' : 'add_circle') : 'search'"></AppIcon>
        </span>
        <h5 class="app-modal-header__title">
          {{ showQuickAdd ? (editingItem ? 'Editar ' : 'Nuevo ') + control.tag : modal.search.title }}
        </h5>
        <b-badge v-if="!showQuickAdd && table.search.items.length"
                 variant="light"
                 pill
                 class="ml-2">
          {{ table.search.items.length }}
        </b-badge>
      </div>

      <b-row class="find-modal-row">

        <!-- all register + agregar -->
        <b-col lg="12" class="find-toolbar mb-3" v-if="!showQuickAdd && (showToolbarControls || multiple)">
          <div class="d-flex align-items-center">
            <b-form-checkbox v-if="control.enabledAllRegister"
                             v-model="allRegister"
                             @input="getAllRegister()"
                             switch
                             size="sm"
                             class="find-switch">
              Todos los registros
            </b-form-checkbox>
            <b-form-checkbox v-if="multiple"
                             v-model="multipleMode"
                             @change="onMultipleModeChange"
                             switch
                             size="sm"
                             class="find-switch ml-3">
              Selección múltiple
            </b-form-checkbox>
            <b-button v-if="quickAddComponent && hasPermission"
                      variant="primary"
                      size="sm"
                      class="find-btn-add ml-auto"
                      @click="toggleQuickAdd()">
              <AppIcon name="add" class="mr-1"></AppIcon>
              Nuevo
            </b-button>
          </div>
        </b-col>

        <template v-if="!showQuickAdd">

          <!-- filtro autoFilter -->
          <b-col lg="12" class="mb-3" v-if="control.autoFilterEnabled && !allRegister">
            <b-input-group size="sm" class="find-search-input">
              <b-input-group-prepend is-text>
                <AppIcon name="search" class="text-muted"></AppIcon>
              </b-input-group-prepend>
              <app-text-input type="text"
                              :placeholder="'Buscar ' + control.tag + '...'"
                              @keyup="find()"
                              @keydown.down.native="focusFirstResult()"
                              v-model="filter"
                              autofocus
                              ref="inputSearch" />
            </b-input-group>
          </b-col>

          <!-- filtro manual -->
          <b-col lg="12" class="mb-3" v-if="!control.autoFilterEnabled && !allRegister" id="popover-help-find">
            <b-input-group size="sm" class="find-search-input">
              <b-input-group-prepend is-text>
                <AppIcon name="search" class="text-muted"></AppIcon>
              </b-input-group-prepend>
              <app-text-input type="text"
                              :placeholder="'Buscar ' + control.tag + ' — Enter para filtrar'"
                              v-on:keyup.enter.native="find('keypress.enter')"
                              @keydown.down.native="focusFirstResult()"
                              v-model="filter"
                              autofocus
                              ref="inputSearch" />
              <b-input-group-append>
                <b-button variant="outline-primary" @click="find('click')">
                  <AppIcon name="filter"></AppIcon>
                  Filtrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-popover target="popover-help-find"
                     triggers="hover"
                     placement="top"
                     boundary="viewport"
                     custom-class="find-help-popover"
                     title="Ayuda">
            <div v-html="control.alert"></div>
          </b-popover>

          <!-- tabla -->
          <b-col lg="12">
            <b-table v-if="table.search.items.length"
                     class="mb-0 app-table app-table--compact find-results-table"
                     responsive
                     :stacked="isMobileViewport ? 'md' : false"
                     hover
                     small
                     :fixed="false"
                     :items="table.search.items"
                     :fields="table.search.fields"
                     :current-page="table.search.currentPage"
                     :per-page="table.search.perPage">

              <template v-slot:cell()="row">
                <div class="find-results-table__value">
                  <DepositLocationLabel v-if="isDepositDisplayColumn(row.field.key)"
                                        :deposit="type === 'deposits' ? row.item : null"
                                        :location="type === 'deposits-location' ? row.item : null" />
                  <template v-else>{{ row.value }}</template>
                  <b-link v-if="isDisplayColumn(row.field.key) && quickAddComponent && hasPermission"
                          href="javascript:void(0);"
                          class="find-edit-icon ml-1"
                          title="Editar"
                          @click="editItem(row.item)">
                    <AppIcon name="edit" font-scale="0.85"></AppIcon>
                  </b-link>
                </div>
              </template>

              <template v-slot:cell(alternative)="row">
                {{ row.value ? 'Sí' : 'No' }}
              </template>

              <template v-slot:cell(active)="row">
                {{ row.value ? 'Sí' : 'No' }}
              </template>

              <template v-slot:cell(f_action)="row">
              <b-form-checkbox v-if="multipleMode"
                               v-model="multipleSelectedIDs"
                               :value="getItemID(row.item)"
                               class="find-result-multiple-check"
                               :aria-label="'Seleccionar ' + (row.item[display] || row.item.name || '')" />
              <b-button v-else
                        variant="primary"
                        size="sm"
                        @click="selectedItem(row.item)"
                        :class="['result-select-btn find-btn-select', { 'find-btn-select--mobile': isMobileViewport }]"
                        title="Seleccionar"
                        :data-index="row.index">
                <span v-if="isMobileViewport">Seleccionar</span>
                <AppIcon name="arrow_circle_right" :font-scale="isMobileViewport ? 1 : 1.25"></AppIcon>
              </b-button>
              </template>

            </b-table>

            <EmptyState v-else-if="searchPerformed"
                        icon="inbox"
                        title="Sin resultados"
                        description="Intentá con otro término de búsqueda" />
            <EmptyState v-else
                        icon="search"
                        title="Buscá para ver resultados"
                        description="Escribí en el campo de arriba para comenzar" />
          </b-col>

          <!-- footer de tabla: columnas + paginador -->
          <b-col lg="6" class="find-table-footer find-table-footer--left" v-if="columnConfig.length > 1">
            <b-dropdown dropup
                        size="sm"
                        variant="outline-secondary"
                        boundary="window"
                        class="find-cols-dropdown">
              <template #button-content>
                <AppIcon name="view_column" class="mr-1"></AppIcon>
                Columnas
              </template>
              <b-dropdown-header>Columnas visibles</b-dropdown-header>
              <b-dropdown-form style="min-width: 160px;">
                <b-form-checkbox v-for="col in columnConfig"
                                 :key="col.key"
                                 :checked="col.visible"
                                 :disabled="col.locked"
                                 size="sm"
                                 class="mb-1"
                                 @change="toggleColumn(col)">
                  {{ col.label }}
                </b-form-checkbox>
              </b-dropdown-form>
            </b-dropdown>
          </b-col>
          <b-col :lg="columnConfig.length > 1 ? 6 : 12" class="find-table-footer">
            <b-pagination class="mb-0 justify-content-end"
                          size="sm"
                          pills
                          :total-rows="getRowCount(table.search.items)"
                          :per-page="table.search.perPage"
                          v-model="table.search.currentPage"/>
          </b-col>

        </template>

        <!-- formulario alta / edición -->
        <b-col lg="12" v-if="quickAddComponent && showQuickAdd">
          <div v-if="editingItem" class="find-edit-id mb-3">
            <span class="find-edit-id-label">ID</span>
            <span class="find-edit-id-value"># {{ editingItem.id }}</span>
          </div>
          <component :is="quickAddComponent"
                     :item="editingItem"
                     :view-edit="control.viewEdit"
                     :view-edit-param-id="control.viewEditParamID"
                     :extra-filter-data="extraFilterData"
                     @saved="onQuickAddSaved"
                     @cancel="closeQuickAdd" />
        </b-col>

      </b-row>

      <template #modal-footer>
        <b-button v-if="multipleMode"
                  variant="primary"
                  size="sm"
                  :disabled="!multipleSelectedIDs.length"
                  @click="selectedMultipleItems()">
          Agregar seleccionados ({{ multipleSelectedIDs.length }})
        </b-button>
        <b-button variant="outline-secondary"
                  size="sm"
                  @click="closeSearch()">
          <AppIcon name="x" class="mr-1"></AppIcon>
          Cerrar
        </b-button>
      </template>

    </b-modal>
  </div>
</template>
<script>  
  import serviceAPI from './services'
  import FIND_CONFIG from './findConfig'
  import QUICK_ADD_FORMS from './forms/index.js'
  import ErrorToken from '@/handler/errorToken'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import Storage from '@/handler/storageSession'
  import Session from '@/handler/session'

  export default {
    props: {
      render: {
        type: String,
        default: 'search'
      },
      type:{
        type: String,
        required: true
      },
      valueID: {
        type: Number,
        default: 0,
      },  
      valueSTR: {
        type: String,
        default: '',
      },
      selectedObject: {
        type: Object,
        default: null,
      },
      referenceSTR: {
        type: String,
        default: '',
      },      
      tag: {
        type: String,
        default: ''
      },
      where: {
        type: Array,
        default: function () { return [] }       
      },
      orWhere: {
        type: Array,
        default: function () { return [] }       
      },      
      description: {
        type: String,
        default: ''
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      showAllRegister: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,        
      },
      display: {
        type: String,
        default: 'name'
      },
      persistLastSearch: {
        type: Boolean,
        default: false,
      },
      extraFilterData: {
        type: Object,
        default: function () { return {} }
      },
      // Al montar sin un valor precargado (sin valueID/valueSTR/selectedObject),
      // fuerza una búsqueda sin texto (respetando where/extraFilterData) y si
      // hay un único resultado lo preselecciona automáticamente. Si hay más de
      // uno, no hace nada y queda a elección del usuario como siempre. Opt-in
      // por implementación -- pensado para combos donde en la práctica casi
      // siempre hay un solo dato posible (ej: un único depósito, una única
      // lista de precios activa) y hacer que el usuario abra el buscador y
      // seleccione el único resultado es solo un paso de más.
      autoSelectSingle: {
        type: Boolean,
        default: false,
      },
      // Opt-in: conserva la selección unitaria por defecto y permite a los
      // consumidores que lo necesiten recibir varios registros completos.
      multiple: {
        type: Boolean,
        default: false,
      },
    },
    data: () => {
      return {     
        parameters: {
          codeCustomer: Helper.hasParametersAccess(Param.P2),
          codeSuppliers: Helper.hasParametersAccess(Param.P3),
          origenProducts: Helper.hasParametersAccess(Param.P62),
        },                        
        filter: '',           
        selectID: 0,
        data: [],                    
        selectObject: null,
        control: {
          tag:'',
          alert: '',
          list: [],
          fieldList: [],
          urlShowAPI: '',
          urlFilterAPI: '',   
          searchResultLength: 0,
          autoFilterEnabled: true,
          enabledAllRegister: true,
          viewAdd: '',
          viewEdit: '',
          viewEditParamID: '',
          permission: null,
        },
        modal: {
          search: {
            active: false,
            title: ''
          },
        },
        table : {
          search: {
            items: [],
            fields: [],
            currentPage: 1,
            perPage: 10,          
          }
        }, 
        allRegister: false,            
        showQuickAdd: false,
        editingItem: null,
        searchPerformed: false,
        columnConfig: [],
        multipleSelectedIDs: [],
        multipleMode: false,
        isMobileViewport: false,
      }      
    },    
    computed: {
      isObjectSelected() {
        return this.selectObject == null ? null : true
      },
      quickAddComponent() {
        return QUICK_ADD_FORMS[this.type] || null
      },
      showToolbarControls() {
        return this.control.enabledAllRegister || (this.quickAddComponent && this.hasPermission)
      },
      hasPermission() {
        var perm = this.control.permission
        if (!perm) return true
        var session = Session.getSession()
        if (!session || !session.auth) return false
        var items = session.auth.user.permissions.items
        for (var i in items) {
          if (items[i].module_id == perm.module_id &&
              items[i].profile_id == perm.profile_id &&
              items[i].reference == perm.view_reference) {
            return true
          }
        }
        return false
      },
    },    
    beforeDestroy() {
      document.removeEventListener('keydown', this._modalKeydownHandler)
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },    
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.config()

      var hasPreselection = !!(this.selectedObject || this.valueID || this.valueSTR)

      if(this.selectedObject) {
        this.setSelectedObject(this.selectedObject)
      } else if(this.valueID) {
        this.selectID = this.valueID
        this.selected()
      }

      if(this.valueSTR) {
        this.selectID = this.valueSTR
        this.selected()
      }

      if(!hasPreselection && this.autoSelectSingle) {
        this.autoSelectIfSingleMatch()
      }

      if(this.tag) {
        this.control.tag = this.tag
      }

      if(this.showAllRegister) {
        this.allRegister = true
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this._applyColumnConfig()
      },
      isDisplayColumn(key) {
        return key === this.display
      },
      isDepositDisplayColumn(key) {
        return ['deposits', 'deposits-location'].includes(this.type) && this.isDisplayColumn(key)
      },
      config() {
        const cfg = FIND_CONFIG[this.type]
        if (!cfg) return

        const { init, allRegister, ...controlFields } = cfg
        Object.assign(this.control, controlFields)

        if (allRegister) this.allRegister = allRegister
        if (init) init(this)
      },

      setSelectedObject(object) {
        if(!object) {
          return false
        }

        if(this.referenceSTR && object[this.referenceSTR]) {
          this.selectID = object[this.referenceSTR]
        } else {
          this.selectID = object.id
        }

        this.filter = object[this.display] || object.name || ''
        this.selectObject = object
        this.$emit('select-object', object)
      },

      // auto-select-single: busca sin texto (mismos where/extraFilterData de
      // siempre) y si hay un único resultado lo preselecciona, como si el
      // usuario hubiera abierto el buscador y lo hubiera elegido a mano. Si
      // hay 0 o más de 1, no hace nada -- el campo queda vacío y a elección
      // del usuario, igual que sin este prop.
      autoSelectIfSingleMatch() {
        serviceAPI.filter(null, this.where, this.control, this.orWhere, this.extraFilterData)
          .then((response) => {
            var data = response.data || []
            if(data.length === 1) {
              this.setSelectedObject(data[0])
            }
          })
          .catch(() => {
            // Silencioso a propósito: si falla, el campo queda vacío y el
            // usuario puede buscar manualmente como siempre.
          })
      },

      // busqueda en la base de datos
      find(event='keyup') {                     
        // no es autofiltro y no se 
        if(!this.control.autoFilterEnabled && event=='keyup' && this.render=='search') {
          return false
        }
        
        if(this.render=='search') {
          this.filter = this.filter.trim()
        }        
        
        if(this.filter.length>this.control.searchResultLength) {           
          var result = serviceAPI.filter(this.filter, this.where, this.control, this.orWhere, this.extraFilterData)

          result.then((response) => {
            var data = response.data
            this.data = data
            this.table.search.items = data
            this.searchPerformed = true

            if(this.table.search.items.length == 1 && !this.multipleMode) {
              this.removeFilterStorage()
              this.selectedItem(this.table.search.items[0])
            } else {
              this.saveFilterStorage()
              // en el restore automático de persistLastSearch el foco debe
              // quedar en el input (para seguir buscando), no saltar a la
              // primera fila como en una búsqueda manual del usuario.
              if(event !== 'restore') {
                setTimeout(() => { this.focusFirstResult() }, 100)
              }
            }
          })
          .catch(error => {          
            this.$awn.alert(ErrorToken.valid(error))                             
          });        
        } else {
          if(this.render=='search') {
            this.$awn.info("Se necesita un mínimo de " + (parseFloat(this.control.searchResultLength) + 1) + ' caracteres para efectuar el filtro');
            this.table.search.items = []
          }
        }
      },
      getAllRegister() {   
        if(this.allRegister) {     
          var result = serviceAPI.filter(null, this.where, this.control, this.orWhere, this.extraFilterData)

          result.then((response) => {
            var data = response.data
            this.data = data
            this.table.search.items = data
            this.searchPerformed = true

            setTimeout(() => { this.focusFirstResult() }, 100)
          })
          .catch(error => {          
            this.$awn.alert(ErrorToken.valid(error))                             
          });                
        } else {
          this.table.search.items = []
        }
      },
      selectedMultipleItems() {
        if(!this.multipleSelectedIDs.length) {
          return false
        }

        var ids = this.multipleSelectedIDs.slice()
        Promise.all(ids.map((id) => {
          return serviceAPI.selected(id, this.where, this.control, this.orWhere)
            .then((response) => response.data)
        }))
        .then((items) => {
          var selected = items.filter((item) => item && Object.keys(item).length)
          if(!selected.length) {
            this.$awn.info('No se pudieron cargar los registros seleccionados')
            return false
          }
          this.multipleSelectedIDs = []
          document.removeEventListener('keydown', this._modalKeydownHandler)
          this.modal.search.active = false
          this.$emit('select-objects', selected)
        })
        .catch((error) => {
          this.$awn.alert(ErrorToken.valid(error))
        })
      },
      onMultipleModeChange(enabled) {
        if(!enabled) {
          this.multipleSelectedIDs = []
          return
        }
        this.$nextTick(() => {
          this.focusFirstResult()
        })
      },
      refreshSearchResults() {
        var filter = this.allRegister ? null : this.filter

        if(!this.allRegister && filter.length<=this.control.searchResultLength) {
          this.table.search.items = []
          this.searchPerformed = true
          return false
        }

        var result = serviceAPI.filter(filter, this.where, this.control, this.orWhere, this.extraFilterData)

        result.then((response) => {
          var data = response.data
          this.data = data
          this.table.search.items = data
          this.table.search.currentPage = 1
          this.searchPerformed = true

          setTimeout(() => { this.focusFirstResult() }, 100)
        })
        .catch(error => {
          this.$awn.alert(ErrorToken.valid(error))
        });
      },
      getItemID(item) {
        return this.referenceSTR ? item[this.referenceSTR] : item.id
      },
      itemMatchesSearchFilters(item) {
        var id = this.getItemID(item)
        var filter = this.allRegister ? null : this.filter

        if(!id) {
          return Promise.resolve(false)
        }

        return serviceAPI.filter(filter, this.where, this.control, this.orWhere, this.extraFilterData)
          .then((response) => {
            var data = response.data || []
            return data.some((row) => {
              return this.getItemID(row) == id
            })
          })
      },
      selectItemIfValid(item, closeModal) {
        this.itemMatchesSearchFilters(item)
          .then((valid) => {
            if(!valid) {
              this.refreshSearchResults()
              this.$awn.info('El registro no corresponde a los filtros actuales')
              return false
            }

            if(this.referenceSTR) {
              this.selectID = item[this.referenceSTR]
            } else {
              this.selectID = item.id
            }

            this.selected()

            if(closeModal) {
              document.removeEventListener('keydown', this._modalKeydownHandler)
              this.modal.search.active = false
            }
          })
          .catch(error => {
            this.$awn.alert(ErrorToken.valid(error))
          })
      },

      // seleccionar el item 
      selectedItemByString() {
        if(this.filter.includes('-')) {
          if(this.referenceSTR) {            
            this.selectID = this.filter.split('-')[1].trim()            
          } else {
            this.selectID = this.filter.split('-')[0].trim()            
          }          
          this.selected()
        } else {
          this.selected()
        }
      },      
      selectedItem(item) {
        this.selectItemIfValid(item, true)
      }, 
      selected(){        
        var id = 0

        if(this.selectID) {
          id = this.selectID
        }          
        
        if(!id){          
          this.filter = '' 
          this.selectObject = null    
          this.$emit('select-object', null)                         
          return false
        }

        var result = serviceAPI.selected(id, this.where, this.control, this.orWhere)      

        result.then((response) => {          
          var data = response.data 
          
          if(Object.keys(data).length){                   
            this.filter = data[this.display]            
            
            this.selectObject = data   
            this.$emit('select-object', data)       
          } else {
            this.clearObjectSelected()          
            return false
          }        
        })   
        .catch(error => {
          this.clearObjectSelected()
          this.$awn.alert(ErrorToken.valid(error))                   
          return false
        });             
      }, 

      // inline - configuracion de lista desplegable 
      getList(item) {                     
        var value = item.id + ' - '
        this.control.list.forEach(element => {                              
          if(element.split('.').length==1){
            value = value + item[element] + " - "
          } else {
            var valSecondary = item
            element.split('.').forEach(element1 => {
              valSecondary = valSecondary != null ? valSecondary[element1] : ''
            });
            value = value + valSecondary + " - "
          }
        })
        return value.slice(0, -3)
      },

      // search - configuracion modal y table
      getRowCount (items) {
        return items.length
      },       
      openSearch(){
        document.addEventListener('keydown', this._modalKeydownHandler)
        this.modal.search.active = true
        this.modal.search.title = 'Buscador de ' + this.control.tag
        this.searchPerformed = false
        this.setFieldTable()
        this.find()

        if(this.allRegister) {     
          this.getAllRegister()
        }   
        
        this.restoreFilterStorage()
      },
      focusSearchInput() {
        this.$nextTick(() => {
          if(this.$refs.inputSearch) {
            this.$refs.inputSearch.focus()
            this.$refs.inputSearch.select()
          }
        })
      },
      setFieldTable() {
        var showID = true
        if (this.type == 'customers' && this.parameters.codeCustomer) showID = false
        if (this.type == 'suppliers' && this.parameters.codeSuppliers) showID = false

        var available = []
        if (showID) available.push({ key: 'id', label: 'ID' })
        if (this.display && !this.control.list.includes(this.display)) {
          available.push({ key: this.display, label: 'Detalle' })
        }
        this.control.fieldList.forEach((label, i) => {
          available.push({ key: this.control.list[i], label: label })
        })

        var saved = null
        try { saved = JSON.parse(localStorage.getItem('find-cols-' + this.type)) } catch(e) {
          // Si la preferencia guardada no es válida, se usan las columnas por defecto.
        }

        var defaultColumn = available.find(col => col.key === this.display)
        if (!defaultColumn) {
          defaultColumn = available.find(col => col.key === 'name') || available.find(col => col.key !== 'id') || available[0]
        }

        this.columnConfig = available.map(col => ({
          key: col.key,
          label: col.label,
          locked: col.key === this.display,
          visible: saved ? saved.indexOf(col.key) !== -1 : defaultColumn && col.key === defaultColumn.key,
        }))
        // la columna de display nunca se oculta
        this.columnConfig.forEach(col => { if (col.locked) col.visible = true })

        this._applyColumnConfig()
      },
      _applyColumnConfig() {
        this.table.search.fields = []
        this.columnConfig.forEach(col => {
          if (col.visible) {
            this.table.search.fields.push({ key: col.key, label: col.label, class: 'align-middle' })
          }
        })
        this.table.search.fields.push({ key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle' })
      },
      toggleColumn(col) {
        if (col.locked) return
        col.visible = !col.visible
        this._applyColumnConfig()
        var visible = this.columnConfig.filter(c => c.visible).map(c => c.key)
        try { localStorage.setItem('find-cols-' + this.type, JSON.stringify(visible)) } catch(e) {
          // El selector sigue funcionando aunque el navegador bloquee localStorage.
        }
      },      
      closeSearch(){
        document.removeEventListener('keydown', this._modalKeydownHandler)
        this.showQuickAdd = false
        if(this.selectObject) {
          if(this.referenceSTR) {
            this.filter = this.selectObject[this.referenceSTR]            
          } else {
            this.filter = this.selectObject["name"]
          }                    
        }        
        this.modal.search.active = false
      },

      // vaciar objeto seleccionado
      clearObjectSelected() {
        this.filter = ''
        this.selectObject = null    
        this.$emit('select-object', null) 
      },

      // navegacion por teclado en resultados
      focusFirstResult() {
        this.$nextTick(() => {
          var btn = this.multipleMode
            ? document.querySelector('.find-result-multiple-check input')
            : document.querySelector('.result-select-btn')
          if (btn) {
            btn.focus()
            this._highlightActiveRow(btn)
          }
        })
      },
      _highlightActiveRow(button) {
        document.querySelectorAll('.find-result-active').forEach(function(el) {
          el.classList.remove('find-result-active')
        })
        var tr = button.closest('tr')
        if (tr) tr.classList.add('find-result-active')
      },
      _modalKeydownHandler(event) {
        var activeTag = document.activeElement ? document.activeElement.tagName : ''
        var isMultipleCheck = this.multipleMode && document.activeElement &&
          document.activeElement.matches('.find-result-multiple-check input')
        if(event.key === 'Enter' && isMultipleCheck) {
          event.preventDefault()
          document.activeElement.click()
          return
        }
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return
        if ((activeTag === 'INPUT' || activeTag === 'SELECT' || activeTag === 'TEXTAREA') && !isMultipleCheck) return
        event.preventDefault()
        var buttons = this.multipleMode
          ? Array.from(document.querySelectorAll('.find-result-multiple-check input'))
          : Array.from(document.querySelectorAll('.result-select-btn'))
        var currentIndex = buttons.indexOf(document.activeElement)
        if (currentIndex === -1) return
        if (event.key === 'ArrowDown') {
          if (buttons[currentIndex + 1]) {
            buttons[currentIndex + 1].focus()
            this._highlightActiveRow(buttons[currentIndex + 1])
          }
        } else {
          if (currentIndex === 0) {
            if (this.$refs.inputSearch) this.$refs.inputSearch.focus()
            document.querySelectorAll('.find-result-active').forEach(function(el) {
              el.classList.remove('find-result-active')
            })
          } else {
            buttons[currentIndex - 1].focus()
            this._highlightActiveRow(buttons[currentIndex - 1])
          }
        }
      },

      // quick-add form
      toggleQuickAdd() {
        this.editingItem = null
        this.showQuickAdd = !this.showQuickAdd
      },
      editItem(item) {
        this.editingItem = item
        this.showQuickAdd = true
      },
      closeQuickAdd() {
        this.showQuickAdd = false
        this.editingItem = null
      },
      onQuickAddSaved(item) {
        if(this.editingItem) {
          this.closeQuickAdd()
          this.refreshSearchResults()
          return
        }

        this.editingItem = null
        this.showQuickAdd = false
        this.selectItemIfValid(item, true)
      },

      // FILTROS SAVE
      saveFilterStorage() {
        if(this.persistLastSearch) {
          if(this.type=='products') {
            Storage.setValue('inc_find_filter_products', this.filter)
          } 
        }     
      },
      restoreFilterStorage() {
        if(this.persistLastSearch) {
          if(this.type=='products') {
            if(Storage.getValue('inc_find_filter_products')) {
              this.filter = Storage.getValue('inc_find_filter_products')
              this.find('restore')
            }         
          }
        }
      },   
      removeFilterStorage()     {
        if(this.persistLastSearch) {
          if(this.type=='products') {
            Storage.removeValue('inc_find_filter_products')
          }        
        }
      }
    }
  }
</script>

<style>

/* ── Modal ─────────────────────────────────────────── */
.find-modal-body {
  padding: 16px 20px 8px !important;
  background-color: var(--app-color-surface-subtle);
}

/* ── Toolbar ────────────────────────────────────────── */
.find-toolbar {
  background-color: var(--app-color-surface);
  border-radius: 6px;
  padding: 10px 14px !important;
  border: 1px solid var(--app-color-border);
}
.find-switch label {
  font-size: 0.82rem;
  color: var(--app-color-text-secondary);
}
.find-btn-add {
  font-size: 0.78rem;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 500;
}
.find-btn-add.btn-primary,
.find-btn-select.btn-primary {
  background-color: var(--app-color-primary) !important;
  border-color: var(--app-color-primary) !important;
  color: var(--app-color-on-primary) !important;
}
.find-btn-add.btn-primary:hover,
.find-btn-add.btn-primary:focus,
.find-btn-select.btn-primary:hover,
.find-btn-select.btn-primary:focus {
  background-color: var(--app-color-primary-hover) !important;
  border-color: var(--app-color-primary-hover) !important;
}

/* Los formularios rápidos se montan dinámicamente dentro de este modal y
   conservaban `variant="dark"` en sus botones Guardar. */
.find-modal-body .btn-dark {
  background-color: var(--app-color-primary) !important;
  border-color: var(--app-color-primary) !important;
  color: var(--app-color-on-primary) !important;
}
.find-modal-body .btn-dark:hover,
.find-modal-body .btn-dark:focus {
  background-color: var(--app-color-primary-hover) !important;
  border-color: var(--app-color-primary-hover) !important;
}

/* Ayuda contextual del filtro manual: una superficie liviana en vez del
   popover informativo celeste heredado de Bootstrap. */
.find-help-popover {
  max-width: min(300px, calc(100vw - 32px));
  border: 1px solid var(--app-color-border) !important;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(25, 45, 62, 0.14);
  font-family: inherit;
}
.find-help-popover .popover-header {
  padding: 7px 10px;
  background: var(--app-color-primary-soft);
  border-bottom: 1px solid var(--app-color-primary-border);
  color: var(--app-color-primary);
  font-size: 0.78rem;
  font-weight: var(--app-font-semibold);
}
.find-help-popover .popover-body {
  padding: 8px 10px;
  background: var(--app-color-surface);
  color: var(--app-color-text-secondary);
  font-size: 0.78rem;
  line-height: 1.4;
}
.find-help-popover.bs-popover-top > .arrow::after {
  border-top-color: var(--app-color-surface);
}
.find-help-popover.bs-popover-top > .arrow::before {
  border-top-color: var(--app-color-border);
}

/* ── Search input ───────────────────────────────────── */
.find-search-input .input-group-text {
  background-color: var(--app-color-surface);
  border-right: none;
  color: var(--app-color-text-muted);
}
.find-search-input .form-control {
  border-left: none;
  font-size: 0.88rem;
  background-color: var(--app-color-surface);
}
.find-search-input .form-control:focus {
  box-shadow: none;
  border-color: var(--app-color-border-strong);
}

/* ── Fila activa teclado ────────────────────────────── */
.find-result-active > td {
  background-color: var(--app-color-primary-soft) !important;
  border-color: var(--app-color-primary-100) !important;
}

/* ── Botón seleccionar ──────────────────────────────── */
.find-btn-select {
  border-radius: 4px !important;
  width: 32px;
  height: 32px;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  float: right;
}

@media (max-width: 767.98px) {
  .find-btn-select--mobile {
    width: auto;
    height: auto;
    padding: 2px 8px !important;
    border-radius: 4px !important;
    gap: 4px;
    float: none;
  }

  /* Igual que los detalles de comprobante: en la tabla apilada cada etiqueta
     ocupa su propia línea y el valor puede usar todo el ancho disponible. */
  .find-results-table.table.b-table.b-table-stacked-md > tbody > tr > td[data-label] {
    display: block !important;
    padding-top: 6px;
    padding-bottom: 6px;
    border-bottom: 2px solid var(--app-color-border);
  }

  .find-results-table.table.b-table.b-table-stacked-md > tbody > tr > td[data-label]::before {
    float: none !important;
    display: block !important;
    width: auto;
    margin-bottom: 2px;
  }

  .find-results-table__value {
    display: block !important;
    width: auto !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .find-results-table.table.b-table.b-table-stacked-md > tbody > tr > td[data-label]::after {
    display: none !important;
    content: none;
  }
}

/* ── Links en tabla ─────────────────────────────────── */
.find-edit-icon {
  color: var(--app-color-icon);
  transition: color 0.15s;
}
.find-edit-icon:hover {
  color: var(--app-color-text-secondary);
}

/* ── Footer tabla ───────────────────────────────────── */
.find-table-footer {
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.find-table-footer--left {
  justify-content: flex-start;
}
.find-table-footer:not(.find-table-footer--left) {
  justify-content: flex-end;
}
.find-cols-dropdown .btn {
  font-size: 0.78rem;
  color: var(--app-color-text-secondary);
  border-color: var(--app-color-border);
}
.find-cols-dropdown .btn:hover {
  background-color: var(--app-color-surface-subtle);
}

/* En mobile BootstrapVue apila los campos de cada resultado. El estilo
   general de tablas usa nowrap para desktop, por lo que se restaura el wrap
   solamente en esta presentación vertical del buscador. */
@media (max-width: 767.98px) {
  .find-results-table.table.b-table.b-table-stacked-md > tbody > tr > td {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
}

/* ── ID edición ─────────────────────────────────────── */
.find-edit-id {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: var(--app-color-surface-subtle);
  border: 1px solid var(--app-color-border);
  border-radius: 6px;
  padding: 5px 12px;
}
.find-edit-id-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--app-color-text-muted);
}
.find-edit-id-value {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--app-color-text-secondary);
  font-family: monospace;
}

/* ── Modal footer ───────────────────────────────────── */
.find-modal-body ~ .modal-footer {
  background-color: var(--app-color-surface-subtle);
  border-top: 1px solid var(--app-color-border);
  padding: 10px 20px;
}

</style>
